import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button,FormControl, MenuItem, Select, InputLabel, Box, Checkbox, FormControlLabel } from '@mui/material';

const CustomerModal = ({ open, onClose, onSave, initialData }) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (open) {
      setFormData(initialData || {
        CUSTOMER_NAME: '',
        BANK: '',
        BANK_ACCOUNT: '',
        ACCOUNT_HOLDER: '',
        IN_OUT: null,
        DIVISION: null,
        ETC_YN: 'N'
      });
    }
  }, [open, initialData]);

  const handleChange = (e) => {
      const { name, value } = e.target;

      setFormData(prev => {
          const updated = { ...prev, [name]: value };

          // 거래처명 입력 시 예금주 자동 반영
          if (name === 'CUSTOMER_NAME') {
              if (!prev.ACCOUNT_HOLDER || prev.ACCOUNT_HOLDER === prev.CUSTOMER_NAME) {
                  updated.ACCOUNT_HOLDER = value;
              }
          }

          return updated;
      });
  };

  const handleSave = () => {
    if (!formData.CUSTOMER_NAME || formData.CUSTOMER_NAME.trim() === '') {
      alert('거래처명은 필수 입력 항목입니다.');
      return;
    }
    onSave(formData);
  };

  if (!open) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{initialData ? '거래처 정보 수정' : '새 거래처 추가'}</DialogTitle>
      <DialogContent>
        {/* 거래처명  */}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField autoFocus margin="dense" name="CUSTOMER_NAME" label="거래처명 *"
            type="text" variant="standard" value={formData.CUSTOMER_NAME || ''}
            onChange={handleChange} sx={{ flex: 2 }} />

        </Box>

        {/* 은행 + 계좌번호 + 예금주 */}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField margin="dense" name="BANK" label="은행"
            type="text" variant="standard" value={formData.BANK || ''}
            onChange={handleChange} sx={{ flex: 1 }} />
          <TextField margin="dense" name="BANK_ACCOUNT" label="계좌번호"
            type="text" variant="standard" value={formData.BANK_ACCOUNT || ''}
            onChange={handleChange} sx={{ flex: 2 }} />
          <TextField margin="dense" name="ACCOUNT_HOLDER" label="예금주"
            type="text" variant="standard" value={formData.ACCOUNT_HOLDER || ''}
            onChange={handleChange} sx={{ flex: 1 }} />
        </Box>

        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <FormControl variant="standard" margin="dense" sx={{ flex: 1 }}>
            <InputLabel>매입/매출</InputLabel>
            <Select value={formData.IN_OUT || ''}
              onChange={(e) => setFormData(prev => ({ ...prev, IN_OUT: e.target.value }))}>
              <MenuItem value=""><em>선택 안함</em></MenuItem>
              <MenuItem value="매입">매입</MenuItem>
              <MenuItem value="매출">매출</MenuItem>
            </Select>
          </FormControl>
          <FormControl variant="standard" margin="dense" sx={{ flex: 1 }}>
            <InputLabel>구분</InputLabel>
            <Select value={formData.DIVISION || ''}
              onChange={(e) => setFormData(prev => ({ ...prev, DIVISION: e.target.value }))}>
              <MenuItem value=""><em>선택 안함</em></MenuItem>
              <MenuItem value="장비">장비</MenuItem>
              <MenuItem value="자재외">자재외</MenuItem>
            </Select>
          </FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.ETC_YN === 'Y'}
                onChange={(e) => setFormData(prev => ({ ...prev, ETC_YN: e.target.checked ? 'Y' : 'N' }))}
              />
            }
            label="기타경비"
            sx={{ mt: 2, flex: 1 }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>취소</Button>
        <Button onClick={handleSave} variant="contained">저장</Button>
      </DialogActions>
    </Dialog>
  );
};


export default CustomerModal;
